<script setup lang="ts">

import FaqItem from "./FaqItem.vue";
import { useAppConfiguration } from "@domain/AppConfiguration";

const app = useAppConfiguration();

</script>

<template>

    <div class="bg-gradient-to-b from-gray-800 to-transparent">

        <div class="px-4 pt-6 pb-3 lg:pt-8 text-lg 3xl:text-xl">
            Health Monitor FAQ
        </div>

        <FaqItem>
            <template #title>I have a Health Monitor installed, how do I connect my phone?</template>
            <p>
                Pairing the Health Monitor with Carbucks is quick and easy. Click on the link below for clear instructions for pairing your Health Monitor
            </p>
            <p>
                <JupiterButton type="url"
                               to="https://support.carbucks.com.au/help/how-do-i-install-the-carbucks-vehicle-health-monitor"
                               class="uppercase text-orange-500">
                   Connect the Carbucks App
                </JupiterButton>
            </p>
        </FaqItem>
        
        <FaqItem>
            <template #title>Why do I need a Health Monitor?</template>
            <p>
                It’s like a fitbit for your car.
            </p>
            <p>
                The Carbucks Health Monitor connects your phone to your car's onboard computer, and keeps you connected to your cars vital signs.
            </p>
            <p>
                With the Carbucks Health Monitor plugged in, you'll be notified if any part of your car needs attention, improving your safety and saving you money.
            </p>
            <p>
                And don't worry about privacy, the Carbucks Health Monitor DOES NOT TRACK YOU, and only reports diagnostic data to the Carbucks App on your phone.
            </p>
        </FaqItem>
    
        <FaqItem>
            <template #title>Where can I get one installed?</template>
            <p>
                To get a Carbucks Health Monitor installed contact your dealership.
            </p>
            <p>
                <JupiterButton type="url"
                               :to="app.dealerLocation.linkUrl"
                               class="uppercase text-orange-500">
                   {{ app.dealerLocation.name }}
                </JupiterButton>
            </p>
            <p>
                Or click here to order online from Carbucks and install it yourself.
            </p>
            <p>
                <JupiterButton type="url"
                               to="https://carbucks.com.au/smart-vehicle-health-monitor-order"
                               class="uppercase text-orange-500">
                   Order your Health Monitor
                </JupiterButton>
            </p>
        </FaqItem>
    
        <FaqItem>
            <template #title>I already have a Health Monitor, can I fit it myself?</template>
            <p>
                Installing a Health Monitor is easy, click on the link below for the installation steps.
            </p>
            <p>
                <JupiterButton type="url"
                               to="https://support.carbucks.com.au/help/how-do-i-install-the-carbucks-vehicle-health-monitor "
                               class="uppercase text-orange-500">
                   How to install your Health Monitor
                </JupiterButton>
            </p>
        </FaqItem>
        
    </div>
    
</template>